module.exports = __webpack_public_path__ + "static/img/returnBonus.804ce31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/returnBonus.png
// module id = CqJg
// module chunks = 0